/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A registered device, projected for the Hubble admin view.
 * @export
 * @interface MobileDeviceSummary
 */
export interface MobileDeviceSummary {
  /**
   *
   * @type {string}
   * @memberof MobileDeviceSummary
   */
  mobileDeviceId: string;
  /**
   *
   * @type {string}
   * @memberof MobileDeviceSummary
   */
  userId: string;
  /**
   *
   * @type {string}
   * @memberof MobileDeviceSummary
   */
  platform: string;
  /**
   *
   * @type {string}
   * @memberof MobileDeviceSummary
   */
  environment: string;
  /**
   *
   * @type {string}
   * @memberof MobileDeviceSummary
   */
  deviceName?: string | null;
  /**
   *
   * @type {string}
   * @memberof MobileDeviceSummary
   */
  deviceModel?: string | null;
  /**
   *
   * @type {string}
   * @memberof MobileDeviceSummary
   */
  osVersion?: string | null;
  /**
   *
   * @type {string}
   * @memberof MobileDeviceSummary
   */
  appVersion?: string | null;
  /**
   *
   * @type {string}
   * @memberof MobileDeviceSummary
   */
  lastRegisteredAt: string;
}

/**
 * Check if a given object implements the MobileDeviceSummary interface.
 */
export function instanceOfMobileDeviceSummary(
  value: object,
): value is MobileDeviceSummary {
  if (!("mobileDeviceId" in value) || value["mobileDeviceId"] === undefined)
    return false;
  if (!("userId" in value) || value["userId"] === undefined) return false;
  if (!("platform" in value) || value["platform"] === undefined) return false;
  if (!("environment" in value) || value["environment"] === undefined)
    return false;
  if (!("lastRegisteredAt" in value) || value["lastRegisteredAt"] === undefined)
    return false;
  return true;
}

export function MobileDeviceSummaryFromJSON(json: any): MobileDeviceSummary {
  return MobileDeviceSummaryFromJSONTyped(json, false);
}

export function MobileDeviceSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MobileDeviceSummary {
  if (json == null) {
    return json;
  }
  return {
    mobileDeviceId: json["mobileDeviceId"],
    userId: json["userId"],
    platform: json["platform"],
    environment: json["environment"],
    deviceName: json["deviceName"] == null ? undefined : json["deviceName"],
    deviceModel: json["deviceModel"] == null ? undefined : json["deviceModel"],
    osVersion: json["osVersion"] == null ? undefined : json["osVersion"],
    appVersion: json["appVersion"] == null ? undefined : json["appVersion"],
    lastRegisteredAt: json["lastRegisteredAt"],
  };
}

export function MobileDeviceSummaryToJSON(json: any): MobileDeviceSummary {
  return MobileDeviceSummaryToJSONTyped(json, false);
}

export function MobileDeviceSummaryToJSONTyped(
  value?: MobileDeviceSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    mobileDeviceId: value["mobileDeviceId"],
    userId: value["userId"],
    platform: value["platform"],
    environment: value["environment"],
    deviceName: value["deviceName"],
    deviceModel: value["deviceModel"],
    osVersion: value["osVersion"],
    appVersion: value["appVersion"],
    lastRegisteredAt: value["lastRegisteredAt"],
  };
}
